module.exports = __webpack_public_path__ + "static/media/not_set.07d1b9ed.svg";